// @flow

import { combineReducers } from 'redux';
import appReducer from 'view/duck/reducers';
import { toast } from 'view/common/Toast/reducer';


const reducers = {
  app: appReducer,
  toast,
};

export type Reducers = typeof reducers;
const rootReducer = combineReducers(reducers);

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer/index.js